import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const LoadingSpinner = () => (
  <div align="center">
    <CircularProgress />
  </div>
);

export default LoadingSpinner;